export const STRIPE_REVIEW_AFTER_MS = 5 * 60 * 1000
export const STRIPE_VERIFY_MESSAGE = 'Estamos confirmando el resultado de tu pago. No vuelvas a pagar mientras lo verificamos.'
export const STRIPE_APPROVED_MESSAGE = 'Tu pago está aprobado. Estamos preparando tus entradas y el correo de confirmación. No necesitas pagar otra vez.'
export const STRIPE_DECLINED_MESSAGE = 'Este intento de pago no fue aprobado. Revisa los datos de tu tarjeta o usa otra. Si ves un débito, solicita una revisión de esta compra antes de volver a pagar.'
export const STRIPE_REVOKED_MESSAGE = 'Esta compra fue anulada. Contacta al organizador para revisarla antes de volver a pagar.'
export const STRIPE_REVIEW_MESSAGE = 'Si en 5 minutos no recibes tus entradas, verifica el estado de esta compra. Consultar el estado no realiza otro cobro. Solo reintenta cuando confirmemos que el pago no se completó; si ves un débito, solicita una revisión antes de volver a pagar.'
export const STRIPE_DELAYED_MESSAGE = 'La confirmación está tardando más de lo esperado. Verifica el estado de esta compra antes de volver a pagar. Consultar el estado no realiza otro cobro. Si ves un débito, solicita una revisión.'

export function isVerifiedStripeFailure(data, clientStatus = '') {
  if (data?.status === 'revoked') return true
  // A successful confirmation may arrive before our status/webhook response.
  if (['succeeded', 'processing'].includes(clientStatus)) return false
  return data?.status === 'failed' && data.verification_complete === true
}

export async function checkoutRequestKey(payload, storage, cryptoApi = window.crypto, locks = window.navigator?.locks) {
  if (!storage) { try { storage = window.localStorage } catch (_) { /* private browsing */ } }
  // Only the opaque request key is sent back; no card details are stored here.
  const identity = JSON.stringify({ customer: payload.customer, pos: payload.pos,
    payment_option: payload.payment_option, invoice_items: payload.invoice_items,
    invoice_addons: payload.invoice_addons, total: payload.expected_total ?? payload.total })
  const digest = await cryptoApi.subtle.digest('SHA-256', new TextEncoder().encode(identity))
  const fingerprint = Array.from(new Uint8Array(digest), n => n.toString(16).padStart(2, '0')).join('')
  const storageKey = `fomoStripeCheckout:${fingerprint}`
  const readOrCreate = () => {
    let current
    try { current = JSON.parse(storage?.getItem(storageKey) || 'null') } catch (_) { /* inaccessible storage */ }
    if (current?.key) return { key: current.key, storageKey }
    const result = { key: cryptoApi.randomUUID(), storageKey }
    try { storage?.setItem(storageKey, JSON.stringify({ key: result.key })) } catch (_) { /* inaccessible storage */ }
    return result
  }
  return locks ? locks.request(storageKey, readOrCreate) : readOrCreate()
}

export function forgetCompletedCheckout(attemptToken) {
  try {
    const storage = window.localStorage
    for (let index = storage.length - 1; index >= 0; index--) {
      const key = storage.key(index)
      if (key?.startsWith('fomoStripeCheckout:') && JSON.parse(storage.getItem(key) || '{}').key === attemptToken) storage.removeItem(key)
    }
  } catch (_) { /* storage may be unavailable */ }
}
